module.exports = __webpack_public_path__ + "static/media/agency.862ff945.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/introduction/assets/agency.png
// module id = 352
// module chunks = 0